import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

import { getApplicationSpaBackendUrl } from "@utils";

export const identificationFilesUploadApiKey = "identificationFilesUploadApi";
export const identificationFilesUploadApi = createApi({
  reducerPath: identificationFilesUploadApiKey,
  baseQuery: fetchBaseQuery({ baseUrl: getApplicationSpaBackendUrl() }),
  endpoints: (builder) => ({
    getIdentificationFileUploadToken: builder.query<{ uploadIdToken: string }, number>({
      query: (applicationUserId) => ({
        url: "/identification-files/upload-token",
        params: { applicationUserId },
      }),
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useLazyGetIdentificationFileUploadTokenQuery } = identificationFilesUploadApi;
